import { useEffect } from 'react';
import { toast } from 'sonner';

const UpdatePrompt = () => {
  useEffect(() => {
    const handleUpdate = () => {
      toast('Nova versão disponível!', {
        description: 'Recarregue para atualizar o app.',
        action: {
          label: 'Atualizar',
          onClick: () => window.location.reload(),
        },
        duration: Infinity,
      });
    };

    window.addEventListener('sw-update-available', handleUpdate);
    return () => window.removeEventListener('sw-update-available', handleUpdate);
  }, []);

  return null;
};

export default UpdatePrompt;
